import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/nathan/Documents/GitHub/wmn-cms-docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "umbraco-interface"
    }}>{`Umbraco Interface`}</h1>
    <h2 {...{
      "id": "initial-view"
    }}>{`Initial View`}</h2>
    <p>{`After logging in to WMN Umbraco you will be presented with a dashboard containing a wide array of buttons and features. In this guide you will gain a quick overview of what each button does.`}</p>
    <p><img alt="Interface" src={require("../../../public/cms/interface/interface.png")} /></p>
    <h2 {...{
      "id": "1---the-sections-menu"
    }}>{`1 - The Sections menu`}</h2>
    <ul>
      <li parentName="ul">{`The first button is Content this is where you manage your content.`}</li>
      <li parentName="ul">{`The next button is Media, under this tab you can manage images and other media files.`}</li>
      <li parentName="ul">{`The next button is Forms, under this tab you can manage online forms.`}</li>
    </ul>
    <h2 {...{
      "id": "2---the-section-tree"
    }}>{`2 - The Section tree`}</h2>
    <p>{`The section tree will be different depending on what section you are on. The section will allow you an overview of the nodes that is contained in the tree. In the this case you are looking at the content section. The first field is Content this allows you to create content nodes, and manage your content tree. When you hover over the sections, it will highlight with a darker color indicating that you are hovering over it. A button with three dots will show up, clicking this will present you with additional options. There will be other option if you right click the field. The Recycle bin, this is where your deleted content ends up. This will be on the Content section and the media section only.`}</p>
    <h2 {...{
      "id": "3---search-and-help"
    }}>{`3 - Search and help`}</h2>
    <p>{`The first button is a search field where you can search for the content, that you are looking for. The second button is the help button if you click this you will get options for help. The third button is your profile, this will give you the option to edit your profile and password.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      